import { render, staticRenderFns } from "./CadastrarEscalasDepartamento.vue?vue&type=template&id=4f058e9c"
import script from "./CadastrarEscalasDepartamento.vue?vue&type=script&lang=js"
export * from "./CadastrarEscalasDepartamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports